<header id="header" role="banner">
  <div class="logo-toggle-flex">
    <div class="logo">
      <img id="header-img" src="../../../assets/default-logo.png" alt="DineNGo Restaurant Technology Platform" title="DineNGo">
    </div>
    <a [matMenuTriggerFor]="menu" id="menu-toggle" class="menu-toggle" aria-label="Open navigation menu">
      <span class="fas fa-bars fa-lg"></span>
    </a>
  </div>
  <div class="menu-container" id="menu-toggle">
    <mat-menu #menu="matMenu">
      <button mat-menu-item routerLink="/login" *ngIf="!currentUser">
        <mat-icon>login</mat-icon>
        <span>Login</span>
      </button>
      <button mat-menu-item routerLink="/register" *ngIf="!currentUser">
        <mat-icon>app_registration</mat-icon>
        <span>Register</span>
      </button>
      <button mat-menu-item routerLink="/sidebar/admin/dashboard" *ngIf="selectedRole === 'Admin'">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
      </button>
      <button mat-menu-item routerLink="/select-role" *ngIf="currentUser && selectedRole !== 'Admin'">
        <mat-icon>supervisor_account</mat-icon>
        <span>Dashboard</span>
      </button>
    </mat-menu>
  </div>
  <nav class="nav-bar-wrapper" id="nav-bar" aria-label="Main navigation">
    <ul class="menu-wrapper" id="menu-wrapper">
      <li><a routerLink="/register" class="nav-link" *ngIf="!currentUser">Register</a></li>
      <li><a routerLink="/login" class="nav-link login-button" *ngIf="!currentUser">Login</a></li>
      <li><a routerLink="/sidebar/admin/dashboard" class="nav-link login-button"
             *ngIf="currentUser?.role.includes('Admin')">Dashboard</a></li>
      <li><a routerLink="/select-role" class="nav-link login-button" *ngIf="currentUser?.role.length > 1">Dashboard</a></li>
    </ul>
  </nav>
</header>

<main id="main-content">

  <!-- Hero / CTA -->
  <section class="cta-img" id="cta-img" aria-labelledby="hero-heading">
    <div class="cta-banner">
      <div class="cta-wrapper">
        <div #container class="image-carousel-container" [ngStyle]="{width: 400+'px'}">
          <ng-image-slider #nav [images]="imageObject" [infinite]="true" [manageImageRatio]=false
                           [autoSlide]="5"
                           [animationSpeed]="0.1"
                           [imageSize]="{width: container.style.width, height: container.style.height, space: 0}"
                           slideImage="1"></ng-image-slider>
        </div>

        <h1 id="hero-heading" class="header">Revolutionize Your Dining Experience</h1>
        <p class="subHeader">
          Transform your dining service, enhance efficiency, and boost profits with our innovative restaurant technology platform.
        </p>

        <ul class="item-type" aria-label="Platform highlights">
          <li class="list-item"><i class="fa fa-check-circle" aria-hidden="true"></i> 0% Commission</li>
          <li class="list-item"><i class="fa fa-bullhorn" aria-hidden="true"></i> Marketing &amp; Promotions</li>
          <li class="list-item"><i class="fa fa-mobile-alt" aria-hidden="true"></i> Serverless Ordering</li>
          <li class="list-item"><i class="fa fa-chart-line" aria-hidden="true"></i> Order History &amp; Analytics</li>
          <li class="list-item"><i class="fa fa-tv" aria-hidden="true"></i> Unlimited Rewards and Kitchen Display Systems (KDS)</li>
          <li class="list-item"><i class="fa fa-qrcode" aria-hidden="true"></i> Unlimited Kiosks, QR Codes &amp; Table Ordering Devices</li>
        </ul>

        <a target="_blank" rel="noopener noreferrer"
           href="https://drivensoftwaresolutions.com/contact/"
           class="quote-btn" aria-label="Schedule a free demo with DineNGo">
          Schedule Demo
        </a>
      </div>
    </div>
  </section>

  <!-- Features -->
  <section class="products" id="products" aria-labelledby="features-heading">
    <h2 id="features-heading">Features</h2>
    <p class="section-subtext">Everything you need to run a modern, efficient restaurant</p>
    <div class="products-wrap">
      <article class="product-item">
        <div class="product-icon-wrap">
          <img class="beam-img" src="../../../assets/qr-icon.png" width="64" height="64" alt="QR code ordering icon" loading="lazy">
        </div>
        <div class="product-description">
          <h3 class="product-label">QR Code &amp; Website Ordering</h3>
          <hr class="hr-line">
          <ul class="item-type" aria-label="QR Code features">
            <li class="list-item">0% Commission</li>
            <li class="list-item">Accept Payment</li>
            <li class="list-item">Ordering Website</li>
            <li class="list-item">Self Fulfilled Delivery</li>
          </ul>
        </div>
      </article>
      <article class="product-item">
        <div class="product-icon-wrap">
          <img class="bolt-img" src="../../../assets/kiosk-icon2.png" width="64" height="64" alt="Kiosk and table ordering icon" loading="lazy">
        </div>
        <div class="product-description">
          <h3 class="product-label">Kiosks &amp; Table Ordering</h3>
          <hr class="hr-line">
          <ul class="item-type" aria-label="Kiosk features">
            <li class="list-item">Turn Any Device Into A Kiosk</li>
            <li class="list-item">Enable/Disable Payment From Kiosk</li>
            <li class="list-item">Games at The Table</li>
          </ul>
        </div>
      </article>
      <article class="product-item">
        <div class="product-icon-wrap">
          <img class="bar-img" src="../../../assets/rewards.png" width="64" height="64" alt="Rewards and marketing icon" loading="lazy">
        </div>
        <div class="product-description">
          <h3 class="product-label">Rewards &amp; Marketing</h3>
          <hr class="hr-line">
          <ul class="item-type" aria-label="Rewards features">
            <li class="list-item">Loyalty Rewards</li>
            <li class="list-item">Auto Redeem Rewards on Kiosk</li>
            <li class="list-item">Send Customers Promotional Texts</li>
          </ul>
        </div>
      </article>
      <article class="product-item">
        <div class="product-icon-wrap">
          <img class="compass-img" src="../../../assets/managing-icon.png" width="64" height="64" alt="Manager and server tools icon" loading="lazy">
        </div>
        <div class="product-description">
          <h3 class="product-label">Manager &amp; Servers</h3>
          <hr class="hr-line">
          <ul class="item-type" aria-label="Manager features">
            <li class="list-item">Manage Tables From Any Device</li>
            <li class="list-item">Sales Analytics</li>
            <li class="list-item">Assign Tables to Servers</li>
            <li class="list-item">Multi-theme Support</li>
            <li class="list-item">Manage All Orders, Inventory &amp; more</li>
          </ul>
        </div>
      </article>
      <article class="product-item">
        <div class="product-icon-wrap kds-icon-wrap">
          <i class="fa fa-tv kds-feature-icon" aria-hidden="true"></i>
        </div>
        <div class="product-description">
          <h3 class="product-label">Kitchen Display System (KDS)</h3>
          <hr class="hr-line">
          <ul class="item-type" aria-label="KDS features">
            <li class="list-item">Real-time Order Display</li>
            <li class="list-item">Color-coded Urgency Alerts</li>
            <li class="list-item">Card &amp; List View Modes</li>
            <li class="list-item">Label Printing &amp; Auto-bump</li>
            <li class="list-item">Works on Any Screen or Device</li>
          </ul>
        </div>
      </article>
      <article class="product-item">
        <div class="product-icon-wrap order-status-icon-wrap">
          <i class="fa fa-eye order-status-icon" aria-hidden="true"></i>
        </div>
        <div class="product-description">
          <h3 class="product-label">Order Status Display</h3>
          <hr class="hr-line">
          <ul class="item-type" aria-label="Customer order status features">
            <li class="list-item">Live "Now Serving" Board</li>
            <li class="list-item">In-Progress &amp; Ready Columns</li>
            <li class="list-item">Auto-updates as Orders are Bumped</li>
            <li class="list-item">Works on Any TV or Screen</li>
            <li class="list-item">No Customer App Required</li>
          </ul>
        </div>
      </article>
    </div>
  </section>

  <!-- About / Driven Payments -->
  <section class="about" id="about" aria-labelledby="about-heading">
    <div class="about-text">
      <h2 id="about-heading" class="driven-payments-text">Driven Payments</h2>
      <div class="about-wrapper">
        <img src="../../../assets/clover-station-promo.jpg" alt="Clover payment station at a restaurant" loading="lazy">
        <div class="p-text">
          <p class="helvetica driven-payments-text">Unlock Savings With Driven Payments</p>
          <p class="helvetica">We partnered with Driven Payment to offer DineNGo members payment processing at a wholesale rate.</p>
          <ul class="item-type helvetica" aria-label="Driven Payments benefits">
            <li class="list-item">Rates as low as 0%</li>
            <li class="list-item">Cash Discounting (Dual Pricing)</li>
            <li class="list-item">Free and Low Cost Device Options</li>
            <li class="list-item">Free Kiosk</li>
            <li class="list-item">Manage All Orders, Inventory &amp; more</li>
          </ul>
          <a target="_blank" rel="noopener noreferrer" class="driven-payments-button"
             href="https://drivenpayments.com" aria-label="Learn more about Driven Payments">Learn More</a>
        </div>
        <div class="acc-logo" aria-label="Payment partners">
          <img src="https://www.clover.com/web-react/assets/clover-logo-gde.svg"
               alt="Clover POS partner" loading="lazy">
        </div>
      </div>
    </div>
  </section>

  <!-- Customers / Testimonials -->
  <section class="clients-video" id="clients-video" aria-labelledby="customers-heading">
    <div class="customers">
      <h2 id="customers-heading">Our Customers</h2>
      <div class="client-logo-wrapper" aria-label="Customer logos">
        <img class="partner-logo-img" src="https://drivenpayments.com/wp-content/uploads/2024/08/sultana-logo.webp"
             width="130" alt="Sultana Lounge Cafe" loading="lazy">
        <img class="partner-logo-img" src="https://drivenpayments.com/wp-content/uploads/2024/08/snowflake-logo-1.webp"
             width="130" alt="Snowflake Tea House" loading="lazy">
        <img class="partner-logo-img" src="https://drivenpayments.com/wp-content/uploads/2024/08/murrays-logoi.webp"
             width="130" alt="Murray In A Hurry" loading="lazy">
        <img class="partner-logo-img" src="https://drivenpayments.com/wp-content/uploads/2024/08/mazdio-logo.webp"
             width="130" alt="Mazdio" loading="lazy">
      </div>
    </div>
    <figure class="quote-wrapper" *ngIf="selectedTestimonial" aria-live="polite" aria-label="Customer testimonial">
      <blockquote>
        <p class="testimonial-text">{{selectedTestimonial.testimonial}}</p>
      </blockquote>
      <figcaption>
        <cite>— {{selectedTestimonial.name}}</cite>
      </figcaption>
    </figure>
  </section>

  <!-- Contact -->
  <section class="contact" id="contact" aria-label="Contact and documentation">
    <h2 class="contact-heading">Get Started Today</h2>
    <p class="contact-subtext">Explore our docs or reach out — we'll get you set up for free</p>
    <div class="contact-wrapper">
      <a class="doc-button" target="_blank" rel="noopener noreferrer"
         href="https://drivensoftwaresolutions.com/docs/" aria-label="View DineNGo documentation">
        <i class="fa fa-book" aria-hidden="true"></i> View Documentation
      </a>
      <a class="contact-button" target="_blank" rel="noopener noreferrer"
         href="https://drivensoftwaresolutions.com/contact/" aria-label="Contact DineNGo support">
        <i class="fa fa-envelope" aria-hidden="true"></i> Contact Us
      </a>
    </div>
  </section>

</main>

<footer role="contentinfo">
  <div id="footer">
    <p>© 2025
      <a target="_blank" rel="noopener noreferrer" href="https://drivensoftwaresolutions.com">Driven Software Solutions</a>
      &mdash; A Driven Software Solution
    </p>
  </div>
</footer>
